import axios from 'axios';

const xmlApi = axios.create({
  baseURL: 'https://xml.secran.digital/api',
});

export default xmlApi;
